import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vimannagartomumbaicab() {



const cardData = {
  keyword: " Viman Nagar to Mumbai Cabs   ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Viman Nagar to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Viman Nagar to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Viman Nagar to Mumbai cab travel.",

topPlaces: [
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is one of Mumbai's most sacred temples dedicated to Lord Ganesha. Visitors hiring an Innova Crysta on rent in Pune can conveniently visit this famous spiritual destination to seek blessings while experiencing the temple's peaceful atmosphere and remarkable architecture."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic coastal promenade known for its cool sea breeze, beautiful skyline, and stunning sunset views. Travelers choosing an Innova Crysta on rent in Pune can relax by the waterfront, enjoy leisurely walks, and admire spectacular views of the Arabian Sea and the Bandra-Worli Sea Link."
  },
   {
    title: "Elephanta Caves",
    description: "Elephanta Caves is a UNESCO World Heritage Site located on Elephanta Island and is one of Mumbai's most remarkable historical attractions. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive to the Gateway of India before taking a ferry to explore the ancient rock-cut caves. The impressive sculptures, especially the massive Trimurti of Lord Shiva, make it a must-visit destination for history lovers and photographers."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful destination surrounded by lush greenery, luxury hotels, cafés, and scenic walking paths. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this beautiful location to enjoy boating, lakeside dining, and relaxing evening strolls. It is an ideal spot for families, couples, and anyone looking to unwind in the heart of Mumbai."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site renowned for its stunning Victorian Gothic architecture. Travelers renting an Innova Crysta in Pune can conveniently visit this iconic railway station while exploring nearby heritage buildings, local markets, and historic streets that showcase Mumbai's rich colonial legacy."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Travelers hiring an Innova Crysta on rent in Pune can enjoy breathtaking views of the Bandra-Worli Sea Link, explore the ancient fort walls, and capture memorable photographs from one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is one of Mumbai's most famous beaches, attracting visitors with its lively atmosphere, delicious street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune makes the road journey comfortable for families and groups planning a fun-filled beach outing and a relaxing evening by the Arabian Sea."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece and an internationally renowned meditation center near Gorai. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore its magnificent golden dome, peaceful meditation halls, and informative museum while enjoying a calm and spiritual experience."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill offer beautifully landscaped gardens, artistic hedges, and panoramic views of Marine Drive. Travelers renting an Innova Crysta in Pune can spend a peaceful afternoon surrounded by greenery while enjoying one of Mumbai's most popular viewpoints overlooking the Arabian Sea."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's busiest shopping streets, offering trendy fashion, antiques, handicrafts, cafés, and local restaurants. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this lively market and enjoy a memorable shopping experience in the heart of South Mumbai."
  },
 
],



services: [
{
name: "Viman Nagar to Mumbai Airport Cab",
description: "Viman Nagar to Mumbai Airport cab service offers reliable transportation from Viman Nagar in Pune to Chhatrapati Shivaji Maharaj International Airport. Comfortable vehicles with professional drivers ensure safe expressway travel and punctual airport drop services. Pickup services are available from homes, hotels, offices, and IT parks across Viman Nagar."
},
{
name: "Wadgaon Sheri to Mumbai Cab Service",
description: "Wadgaon Sheri to Mumbai cab service provides dependable intercity transportation between Wadgaon Sheri in Pune and Mumbai city. Comfortable vehicles and experienced drivers ensure safe journeys via the Mumbai–Pune Expressway."
},
{
name: "Pune Airport to Mumbai Airport Cab",
description: "Pune Airport to Mumbai Airport cab service offers convenient airport transfer solutions between the two major airports. Spacious vehicles with luggage capacity ensure comfortable travel for passengers carrying baggage."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable transportation for passengers traveling from Pune city to Mumbai Airport terminals. Comfortable vehicles with professional drivers ensure smooth expressway travel."
},
{
name: "Pune Airport to Mumbai International Airport",
description: "Pune Airport to Mumbai International Airport cab service offers dependable airport transfers for passengers traveling for international flights. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Lohegaon to Mumbai Airport Cab Service",
description: "Lohegaon to Mumbai Airport cab service offers reliable airport transportation between Pune’s Lohegaon area and Mumbai Airport terminals. Professional drivers ensure safe expressway travel and punctual pickup services."
},
{
name: "Dhanori to Mumbai Airport Cab",
description: "Dhanori to Mumbai Airport cab service provides dependable airport transfers between Pune’s Dhanori area and Mumbai Airport. Comfortable vehicles and professional drivers ensure smooth and safe journeys."
},
{
name: "Vishrantwadi to Mumbai Cab Service",
description: "Vishrantwadi to Mumbai cab service offers reliable transportation between Pune’s Vishrantwadi area and Mumbai city. Comfortable vehicles ensure smooth expressway travel with professional drivers."
},
{
name: "Yerwada to Mumbai Airport Cab Service",
description: "Yerwada to Mumbai Airport cab service offers convenient airport transportation between Pune’s Yerwada area and Mumbai Airport terminals. Vehicles are comfortable and suitable for long-distance airport journeys."
},
{
name: "Cab Service in Viman Nagar",
description: "Cab service in Viman Nagar provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles with professional drivers ensure safe travel across Viman Nagar and nearby Pune areas."
},
{
name: "Pune Airport Cabs",
description: "Pune Airport cabs service offers quick and reliable taxi transportation for passengers traveling to and from Pune Airport. Comfortable vehicles and professional drivers ensure safe and timely travel."
},
{
name: "Innova Crysta Hire in Viman Nagar",
description: "Innova Crysta hire in Viman Nagar offers premium SUV rental for travelers seeking spacious and comfortable transportation. Ideal for airport transfers, corporate travel, and outstation journeys."
},
{
name: "Ertiga Hire in Viman Nagar",
description: "Ertiga hire in Viman Nagar provides comfortable 7-seater SUV transportation suitable for family trips, airport transfers, and group travel."
},
{
name: "Pune to Mumbai Airport Taxi Fare",
description: "Pune to Mumbai Airport taxi fare services provide transparent pricing for passengers traveling between Pune and Mumbai Airport terminals. Travelers can choose sedan, Ertiga, or Innova vehicles based on comfort and budget."
},
{
name: "Lohegaon to Mumbai Cab Service",
description: "Lohegaon to Mumbai cab service offers dependable transportation between Pune’s Lohegaon area and Mumbai city. Comfortable vehicles ensure smooth expressway travel with experienced drivers."
},
{
name: "Lohegaon to Mumbai Cab Service Price",
description: "Lohegaon to Mumbai cab service price services provide fare estimates for passengers planning travel between Lohegaon in Pune and Mumbai city. Flexible booking options allow easy cab reservations."
},
{
name: "Velocity Cabs Pune",
description: "Velocity Cabs Pune provides dependable taxi services for city rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe and convenient travel."
},
{
name: "Sedan Cabs on Rent in Viman Nagar",
description: "Sedan cabs on rent in Viman Nagar offer economical transportation for city rides and outstation journeys. Vehicles like Swift Dzire and Etios provide comfortable seating and smooth highway travel."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers reliable transportation for local travel, airport transfers, and long-distance journeys. Comfortable vehicles and experienced drivers ensure safe travel across the city."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Cab Service in Viman Nagar Pune",
description: "Cab service in Viman Nagar Pune provides reliable transportation for local rides, airport transfers, and outstation travel. Comfortable vehicles ensure safe journeys with professional drivers."
},
{
name: "Corporate Cab Services in Viman Nagar",
description: "Corporate cab services in Viman Nagar offer professional transportation solutions for business travelers and corporate employees. Comfortable vehicles and experienced drivers ensure safe and punctual travel for office trips and airport transfers."
}
],

tableData: [
["Viman Nagar to Mumbai Airport Cab","Wadgaon Sheri to Mumbai Cab Service"],
["Pune Airport to Mumbai Airport Cab","Pune to Mumbai Airport Cab"],
["Pune Airport to Mumbai International Airport","Lohegaon to Mumbai Airport Cab Service"],
["Dhanori to Mumbai Airport Cab","Vishrantwadi to Mumbai Cab Service"],
["Yerwada to Mumbai Airport Cab Service","Cab Service in Viman Nagar"],
["Pune Airport Cabs","Innova Crysta Hire in Viman Nagar"],
["Ertiga Hire in Viman Nagar","Pune to Mumbai Airport Taxi Fare"],
["Lohegaon to Mumbai Cab Service","Lohegaon to Mumbai Cab Service Price"],
["Velocity Cabs Pune","Sedan Cabs on Rent in Viman Nagar"],
["Cab Service in Pune","Pune Mumbai Cab"],
["Cab Service in Viman Nagar Pune","Corporate Cab Services in Viman Nagar"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Viman Nagar to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic patterns ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Viman Nagar to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming their ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Viman Nagar to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Viman Nagar to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Viman Nagar",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and residential societies across Viman Nagar and nearby areas like Kalyani Nagar, Kharadi, Yerawada, and Koregaon Park."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Viman Nagar to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Viman Nagar to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Viman Nagar to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Viman Nagar to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Viman Nagar to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Viman Nagar to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Viman Nagar and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Viman Nagar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Viman Nagar to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pratik Joshi",
    feedback:
      "Viman Nagar to Mumbai cab service with Velocity Cab was very smooth and comfortable. The car was clean, and the long journey felt safe and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "The Viman Nagar to Mumbai cab ride with Velocity Cab was excellent. The driver was punctual and professional, making the trip hassle-free and comfortable.",
    rating: 5
  }
];






































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Viman Nagar to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Viman Nagar to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Sedan cabs for airport transfers, Pune Airport, Lohegaon, Dhanori, Wadgaon Sheri, Vishrantwadi, Yerwada, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Viman Nagar to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Viman Nagar to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Viman Nagar to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Ertiga, Innova & Sedan cabs for Pune Airport, Lohegaon, Dhanori, Wadgaon Sheri & Vishrantwadi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vimannagartomumbaicab;